<template>
    <v-menu
      v-model="menu"
      :close-on-content-click="false"
      transition="scale-transition"
      offset-y
      min-width="auto"
      content-class="responsive-menu"
    >
      <template #activator="{ props }">
        <v-text-field
          v-bind="props"
          :model-value="formattedRange"
          variant="outlined"
          density="compact"
          hide-details
          placeholder="Период"
          clearable
          @click:clear="clearRange"
          @input="onInput($event)"
          prepend-inner-icon="mdi-filter"
          v-mask="'##.##.#### - ##.##.####'"
        />
      </template> 
  
      <v-date-picker
        v-model="internalRange"
        type="date"
        multiple="range"
        range
        class="date-range-picker"
        @update:model-value="updateRange"
      />
    </v-menu>
  </template>
  
  <script>
  export default {
    name: 'DateRangeFilter',
    props: {
      modelValue: {
        type: Object,
        default: () => ([])
      }
    },
    data() {
      return {
        menu: false,
        formattedRangeValue: null,
        internalRange: []
      }
    },
    computed: {
      formattedRange() {
        const format = d => d.toLocaleDateString('ru-RU');
        if (this.internalRange[0] && this.internalRange?.length > 1) {
          const result = `${format(this.internalRange[0])} - ${format(this.internalRange[this.internalRange?.length - 1])}`;
          return result
        } else if (this.internalRange[0] && this.internalRange?.length == 1) {
          return format(this.internalRange[0])
        }
        else return ''
      }
    },
    watch: {
      // modelValue: {
      //   immediate: true,
      //   handler(val) {
      //     const { start, end } = val || {};
      //     if (start && end) {
      //       const s = this.toDate(start);
      //       const e = this.toDate(end);
      //       if (s && e) this.internalRange = [s, e];
      //       else this.internalRange = [];
      //     } else if (start) {
      //       const s = this.toDate(start);
      //       this.internalRange = s ? [s] : [];
      //     } else {
      //       console.log('11')
      //       this.internalRange = [];
      //     }
      //   }
      // },
    },
    methods: {
      onInput($event) {
        if ($event.target.value?.length == 23) {
          const dateArr = $event.target.value.split(' - ')
          const firstDateStr = dateArr[0]
          const lastDateStr = dateArr[1]
          const [d1, m1, y1] = firstDateStr.split('.').map(Number);
          const [d2, m2, y2] = lastDateStr.split('.').map(Number);

          const firstDate = new Date(y1, m1 - 1, d1);
          const lastDate = new Date(y2, m2 - 1, d2);

          const isValidFirst = firstDate.getFullYear() === y1 && firstDate.getMonth() === m1 - 1 && firstDate.getDate() === d1;
          const isValidLast = lastDate.getFullYear() === y2 && lastDate.getMonth() === m2 - 1 && lastDate.getDate() === d2;

          if (!isValidFirst || !isValidLast) {
            console.warn('Одна (или обе) из дат некорректна');
            return;
          }

          if (firstDate > lastDate) {
            console.warn('Первая дата больше второй');
            return;
          }
          const dateArray = [firstDate, lastDate];
          this.internalRange = dateArray
          this.$emit('update:modelValue', dateArray)
        }
      },
    parseDDMMYYYY(str) {
      if (!str) return null;
      const m = str.trim().match(/^(\d{1,2})\.(\d{1,2})\.(\d{4})$/);
      if (!m) return null;
      const day = Number(m[1]);
      const month = Number(m[2]) - 1;
      const year = Number(m[3]);
      const d = new Date(year, month, day);
      if (d.getFullYear() !== year || d.getMonth() !== month || d.getDate() !== day) return null;
      return d;
    },

    toDate(v) {
      if (!v) return null;
      if (v instanceof Date) return v;
      return this.parseDDMMYYYY(typeof v === 'string' ? v : '');
    },
      updateRange(val) {
        if (val?.length > 1) {
          this.$emit('update:modelValue', val)
          this.menu = false
        }
      },
      clearRange() {
        this.$emit('update:modelValue', { start: '', end: '' })
        this.internalRange = []
      }
    }
  }
  </script>

  <style scoped>
  .date-range-picker {
    position: absolute;
    z-index: 100;
    height: 500px;
    left: 150px;
    top: -200px;
  }

  @media (max-width: 480px) {
    .date-range-picker {
      position: relative;
      height: auto;
      left: auto;
      top: auto;
    }
  }
  </style>
